import { Button, InputDate, Select } from 'uikit'
import { useEffect, useRef, useState } from 'react'
import { PAYMENT_STATE_LABEL } from 'shared/constants/payments'
import { FilterStackGroup } from 'uikit/layout'

export const PaymentsFilters = ({ onChange }) => {
  const [state, setState] = useState({})
  const prevState = useRef(state)

  useEffect(() => {
    if (state !== prevState.current) {
      onChange(state)
      prevState.current = state
    }
  }, [state])

  const handleFilter = (value) => {
    setState((state) => ({ ...state, ...value }))
  }

  const handleResetFilter = () => {
    setState({})
  }

  return (
    <>
      <Select
        name="paymentState"
        label="Статус"
        isSearchable={false}
        placeholder="Выберите"
        value={state?.paymentState}
        options={[
          {
            value: 'all',
            label: 'Все',
          },
          ...Object.entries(PAYMENT_STATE_LABEL).map(([id, field]) => ({
            value: id,
            label: field,
          })),
        ]}
        onChange={(e) => handleFilter({ paymentState: e.value })}
      />
      <FilterStackGroup>
        <InputDate
          value={state?.paymentDateFrom}
          dayPickerProps={{
            showCurrentDate: false
          }}
          name="paymentDateFrom"
          placement="bottom"
          onChange={(e) => handleFilter({ paymentDateFrom: e })}
          label="Дата платежа"
          placeholder="C"
        />
        <InputDate
          value={state?.paymentDateTo}
          dayPickerProps={{
            showCurrentDate: false
          }}
          name="paymentDateTo"
          placement="bottom"
          onChange={(e) => handleFilter({ paymentDateTo: e })}
          placeholder="По"
        />
      </FilterStackGroup>
      <Button size="sm" width="full" onClick={handleResetFilter}>
        Очистить фильтр
      </Button>
    </>
  )
}
